<template>
  <div id="app">
    <mdb-navbar class="indigo" dark>
      <!-- Navbar brand -->
      <mdb-navbar-brand href="https://mdbootstrap.com/">IGOR.time</mdb-navbar-brand>
      <mdb-navbar-toggler>
        <mdb-navbar-nav>
          <mdb-nav-item href="#" active>Home</mdb-nav-item>
          <mdb-nav-item href="#">Features</mdb-nav-item>
          <mdb-nav-item href="#">Pricing</mdb-nav-item>
          <!-- Dropdown -->
          <!-- <mdb-dropdown tag="li" class="nav-item">
            <mdb-dropdown-toggle tag="a" navLink color="indigo" slot="toggle" waves-fixed>Dropdown</mdb-dropdown-toggle>
            <mdb-dropdown-menu>
              <mdb-dropdown-item>Action</mdb-dropdown-item>
              <mdb-dropdown-item>Another action</mdb-dropdown-item>
              <mdb-dropdown-item>Something else here</mdb-dropdown-item>
            </mdb-dropdown-menu>
          </mdb-dropdown> -->
        </mdb-navbar-nav>
        <!-- Search form -->
        <form class="form-inline">
          <input
            class="form-control mr-auto p-2"
            type="text"
            placeholder="Search"
            aria-label="Search"
          >
        </form>
      </mdb-navbar-toggler>
    </mdb-navbar>
    <div class="row">
      <div class="col-1"></div>
      <div
        class="justify-content-center align-items-center align-content-center col-10 align-self-center"
        style="margin-top:30px;"
      >
        <p class="text-center justify-content-center align-items-center">
          <span style="font-size:46px;">{{ today }}</span>
        </p>
      </div>
      <div class="col-1"></div>
    </div>
    <div class="row">
      <div class="col-2"></div>
      <div class="col-8 align-self-center">
        <button
          type="button"
          class="btn btn-circle btn-reload float-right"
          v-on:click="getTodayTime"
        >
          <font-awesome-icon id="updateIcon" icon="sync" :pulse="isUpdating ? true : false"/>
        </button>
        <p
          class="text-center"
          style="font-size:52px;"
          v-bind:class="{
          badTime: spentTime < 4 * 3600,
          goodTie: spentTime > 6 * 3600
          }"
        >
          <span id="hours" style="font-size:127px;">{{ spentHours}}</span>
          :
          <span id="minutes">{{ spentMinutes}}</span>
        </p>
      </div>
      <div class="col-2"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mdbNavbar, mdbNavbarBrand, mdbNavbarToggler, mdbNavbarNav, mdbNavItem } from 'mdbvue';

export default {
  name: "app",
  components: {
    mdbNavbar, mdbNavbarBrand, mdbNavbarToggler, mdbNavbarNav, mdbNavItem
  },
  methods: {
    getTodayTime: function() {
      this.isUpdating = true;
      axios
        .get(
          "https://script.google.com/macros/s/AKfycbzONT1Y5GQRp10C4CnZLgziGWkOWoUkH6f05NlcRvdshyaPhbw/exec?task=spentTime"
        )
        .then(response => {
          this.spentHours = parseInt(response.data / 3600);
          this.spentMinutes = parseInt(
            (response.data - this.spentHours * 3600) / 60
          );
          this.spentTime = response.data;
          this.isUpdating = false;
        })
        .catch(e => {
          console.log(e);
        });
      console.log("Getting today's time");
    }
  },
  data: function() {
    return {
      today: "",
      spentHours: 0,
      spentMinutes: 0,
      spentTime: 0,
      isUpdating: false
    };
  },
  created: function() {
    var today = new Date();
    this.today = `${today.getFullYear()}-${today.getMonth() +
      1}-${today.getDate()}`;
    this.getTodayTime();
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
  background-color: #7986cb;
}

.badTime {
  color: #c62828;
}

.goodTime {
  color: #689f38;
}

.btn-circle {
  width: 30px;
  height: 30px;
  text-align: center;
  padding: 6px 0;
  font-size: 12px;
  line-height: 1.428571429;
  border-radius: 15px;
}

.btn-reload {
  background-color: #3f51b5 ;
  color: white;
}
</style>
